import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_inventory_with_allocations_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { project_id: number[], warehouse_id: number[] }): 
  Promise<{ result: { netWeight?: number, Qty?: number, Lot?: { Id?: number, LookupCode?: string, ReceiveDate?: string, Material?: { LookupCode?: string, Description?: string, Project?: { Name?: string } }, Status?: { Name?: string } }, LicensePlate?: { Location?: { Status?: { Name?: string }, Warehouse?: { Name?: string } } }, inventoryByLot?: { TotalPackagedAmount?: number, AvailablePackagedAmount?: number, InactiveAmount?: number, Allocated?: number, SoftAllocated?: number, LotId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { project_id: number[], warehouse_id: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { netWeight?: number, Qty?: number, Lot?: { Id?: number, LookupCode?: string, ReceiveDate?: string, Material?: { LookupCode?: string, Description?: string, Project?: { Name?: string } }, Status?: { Name?: string } }, LicensePlate?: { Location?: { Status?: { Name?: string }, Warehouse?: { Name?: string } } }, inventoryByLot?: { TotalPackagedAmount?: number, AvailablePackagedAmount?: number, InactiveAmount?: number, Allocated?: number, SoftAllocated?: number, LotId?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { project_id: number[], warehouse_id: number[], $keys: { Lot?: { Id?: number, LookupCode?: string, Material?: { LookupCode?: string, Description?: string, Project?: { Name?: string } }, Status?: { Name?: string }, ReceiveDate?: string }, LicensePlate?: { Location?: { Status?: { Name?: string }, Warehouse?: { Name?: string } } } }[] }): 
  Promise<{ result: { netWeight?: number, Qty?: number, Lot?: { Id?: number, LookupCode?: string, ReceiveDate?: string, Material?: { LookupCode?: string, Description?: string, Project?: { Name?: string } }, Status?: { Name?: string } }, LicensePlate?: { Location?: { Status?: { Name?: string }, Warehouse?: { Name?: string } } }, inventoryByLot?: { TotalPackagedAmount?: number, AvailablePackagedAmount?: number, InactiveAmount?: number, Allocated?: number, SoftAllocated?: number, LotId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.warehouse_id)) {
      $missingRequiredInParams.push('\'warehouse_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      project_id: number[], warehouse_id: number[]    }) {
        if(isNil($inParams.project_id)) {
          return true; 
        }
        if(isNil($inParams.warehouse_id)) {
          return true; 
        }
      return false;
    }
}
